import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowCurveUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M19.8 8.914 14.486 3.6m0 0L9.172 8.914M14.486 3.6v12.8a4 4 0 0 1-4 4H4.2"
    />
  </svg>
);
export default SvgArrowCurveUpRight;
